<template>
    <app-framework>
        <template v-slot:title>
            <divider color="white"
                        width="56"
                        class="mb-3"
            ></divider>
            Customizations
        </template>
        <row>
            <column class="text-secondary" cols="full">
                <row>
                    <column align="end" class="text-right" cols="full">
                        <divider class="mb-5" color="primary" width="56"></divider>
                        <div class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-higher mb-10">
                            Customizations
                        </div>
                        <div
                            class="xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed xs:w-full sm:w-3/4 md:w-1/2 lg:w-2/5">
                            Organizations are different. Why should their approach
                            to talent be the same? fitt Provides the
                            following customization options:
                        </div>
                    </column>
                    <column class="mt-24" cols="full">
                        <!--                    :justify="innerWidth > 1630 ? 'center' : 'start'"-->
                        <row justify="center">
                            <column :key="itemIndex"
                                    align="center"
                                    class="px-6 pt-32 pb-6 justify-center"
                                    lg="1/3" md="1/2" sm="full" v-for="({src, title, subtitle}, itemIndex) in items"
                                    xl="1/4"
                                    xs="full"
                            >
                                <card :style="{ 'max-width': mobile ? '337px' : '381px' }"
                                      class="flex flex-col justify-end items-center text-secondary relative w-full"
                                      no-padding
                                      overflow="visible"
                                      style="min-height: 344px; max-height: 344px;"
                                >
                                    <div class="flex flex-col justify-center items-center absolute px-5"
                                         style="bottom: 20px; left: 0;">
                                        <object :data="requireSrc(src)" :id="'svgObject_'+itemIndex"
                                                @load="initAnimations(itemIndex)"
                                                :style="{ 'max-width': mobile ? '250px' : '300px' }"
                                                class="mb-10"
                                                style="pointer-events: none; width: 100%;"
                                                type="image/svg+xml"
                                        ></object>
                                        <divider class="mb-5" color="primary" width="56"></divider>
                                        <div
                                            class="uppercase poppins-bold text-xl tracking-wide leading-tight my-4 w-full text-center"
                                        >{{ title }}
                                        </div>
                                        <div class="text-xl tracking-tight leading-tight text-center"
                                        >{{ subtitle }}
                                        </div>
                                    </div>
                                </card>
                            </column>
                        </row>
                    </column>
                </row>
                <row class="xs:my-20 sm:my-20 md:my-32" justify="center">
                    <column align="center" class="mb-20" cols="full">
                        <divider class="mb-5" color="primary" width="56"></divider>
                        <div
                            class="poppins-bold text-center tracking-normal xs:text-3xl sm:text-5xl xs:leading-relaxed sm:leading-higher">
                            Want to go even further
                        </div>
                    </column>
                    <column cols="4/5">
                        <row>
                            <column class="md:pr-20 xs:mb-10 sm:mb-10" md="1/2" sm="full" xs="full">
                                <row align="center" class="xs:justify-start md:justify-end" no-wrap>
                                    <card class="flex justify-center items-center mr-4"
                                          round
                                          style="min-width: 71px; max-width: 71px; min-height: 71px; max-height: 71px;"
                                    >
                                        <icon color="primary" icon="clipboard-account"></icon>
                                    </card>
                                    <div class="text-2xl tracking-normal xs:leading-snug sm:leading-relaxed">
                                        Completely customize reports
                                    </div>
                                </row>
                            </column>
                            <column md="1/2" sm="full" xs="full">
                                <row align="center" class="xs:justify-start justify-start" no-wrap>
                                    <card class="flex justify-center items-center mr-4"
                                          round
                                          style="min-width: 71px; max-width: 71px; min-height: 71px; max-height: 71px;"
                                    >
                                        <icon color="primary" icon="check-all"></icon>
                                    </card>
                                    <div class="text-2xl tracking-normal xs:leading-snug sm:leading-relaxed">
                                        Integrate custom questions and measurements
                                    </div>
                                </row>
                            </column>
                        </row>
                    </column>
                </row>
                <row>
                    <column cols="full">
                        <row :wrap-reversed="mobile">
                            <column class="xs:items-center sm:items-center md:items-end md:pr-10" md="1/2" sm="full"
                                    xs="full">
                                <object :data="requireSrc('reporting_further.svg')"
                                        type="image/svg+xml"
                                        style="max-width: 350px; width: 100%;"
                                        id="reporting_further"
                                        @load="initReportingFurtherAnimation()"
                                ></object>
                            </column>
                            <column class="xs:items-center sm:items-center md:items-start md:pl-10 xs:mb-10" md="1/2"
                                    sm="full" xs="full">
                                <div>
                                    <divider class="mb-5" color="primary" width="56"></divider>
                                    <div
                                        class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-higher mb-10">
                                        Reporting
                                    </div>
                                    <div class="text-2xl tracking-normal leading-relaxed mb-10">
                                        The fitt reporting and analytics engine is
                                        <br>
                                        completely customizable to accommodate
                                        <br>
                                        your reporting needs.
                                    </div>
                                    <ul class="tracking-tight leading-relaxed text-md">
                                        <li>Specify custom data lenses</li>
                                        <li>Aggregations and interpretation rules</li>
                                        <li>Reporting formats</li>
                                        <li>Build different reports for different use-cases</li>
                                    </ul>
                                </div>
                            </column>
                        </row>
                    </column>
                </row>
                <row class="xs:mt-16 sm:mt-16 md:mt-32">
                    <column cols="full">
                        <row>
                            <column cols="ful">
                                <divider class="mb-5" color="primary" width="56"></divider>
                                <div class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-higher mb-20">
                                    Measurements
                                </div>
                            </column>
                        </row>
                        <row>
                            <column :key="index"
                                    :lg="'1/' + measurements.length"
                                    :xl="'1/' + measurements.length"
                                    class="p-4"
                                    md="1/2"
                                    sm="full"
                                    v-for="({title, subtitle, icon}, index) in measurements"
                                    xs="full"
                            >
                                <row no-wrap>
                                    <column class="mr-4" shrink>
                                        <card class="flex justify-center items-center" height="71" round width="71">
                                            <icon :icon="icon" color="primary"></icon>
                                        </card>
                                    </column>
                                    <column>
                                        <div class="uppercase poppins-bold tracking-wide leading-tight mb-4"
                                             v-html="title"></div>
                                        <div class="tracking-normal leading-snug">
                                            {{ subtitle }}
                                        </div>
                                    </column>
                                </row>
                            </column>
                        </row>
                    </column>
                </row>
            </column>
        </row>
    </app-framework>
</template>

<script>
    import anime from "animejs";

    export default {
        name: "Customizations",
        components: {
            'divider': () => import('@/components/Divider.vue'),
            icon: () => import('@/components/display/Icon.vue'),
            card: () => import('@/components/Card.vue'),
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
        },
        computed: {
            mobile() {
                return this.innerWidth <= 411;
            }
        },
        data: () => ({
            items: [
                {
                    title: 'Reporting',
                    subtitle: 'Tailored to organizational talent frameworks, competence models and branding',
                    src: 'reporting.svg'
                },
                {
                    title: 'Content',
                    subtitle: 'Specific digital content reflecting employer brand and unique context',
                    src: 'content.svg'
                },
                {
                    title: 'Organizational Level',
                    subtitle: 'Customized for specific application throughout professional, managerial and executive levels',
                    src: 'organizational_level.svg'
                },
                {
                    title: 'Role Specificity',
                    subtitle: 'Match talent data to specific job requirements and demands',
                    src: 'role_specificity.svg'
                },
            ],
            measurements: [
                {
                    title: 'Add technical questions<br>or exercises',
                    subtitle: 'Various answer formats, exercise and gamification options',
                    icon: 'file-document'
                },
                {
                    title: 'Host your own custom<br>tools',
                    subtitle: 'Integrate custom tools and transform them by taking advantage of the existing platform benefits',
                    icon: 'desktop-mac-dashboard'
                },
                {
                    title: 'Have custom tools<br>developed',
                    subtitle: 'Let us develop custom situational judgement and other tests for you. Powered by the Cambridge Psychometric Centre',
                    icon: 'code-tags'
                },
                {
                    title: 'Integrate with other<br>assessment platforms',
                    subtitle: 'If you still can\'t find what you\'re looking for, we\'ll link your existing assessment platforms',
                    icon: 'puzzle'
                }
            ],
            innerWidth: 0,
            options: {
                pageDots: false,
                cellAlign: 'left'
            }
        }),
        methods: {
            setInnerWidth() {
                this.innerWidth = window.innerWidth;
                // this.options.pageDots = this.innerWidth < 1325;
                // if (render && innerWidth < 1360) {
                //     this.$nextTick(() => {
                //         this.$refs.carousel.reRender();
                //     });
                // }
                // if (this.innerWidth < 1000) {
                //     this.options.cellAlign = 'center'
                // } else {
                //     this.options.cellAlign = 'left'
                // }
            },
            requireSrc(src) {
                return require('@/assets/images/components/' + src);
            },
            getElement(main, id) {
                return main.contentDocument.querySelector(id);
            },
            setInitialPosition(target, x, y) {
                anime({targets: target, translateX: x, translateY: y, duration: 0});
            },
            initAnimations(index) {
                if(index === 0) {
                    let main_1 = this.$el.querySelector('#svgObject_'+index),
                        // bubble = this.getElement(main_1, '#Group_437'),
                        person_1 = this.getElement(main_1, '#Group_438'),
                        arm_1 = this.getElement(main_1, '#Path_960'),
                        hand_1 = this.getElement(main_1, '#Path_961'),
                        hand_2 = this.getElement(main_1, '#Path_962');
                    this.setInitialPosition(person_1, 27.15, 5.669);
                    // this.animateBubble([bubble, person_1], 1.05, 4000);
                    this.setInitialPosition(arm_1, -254.485, -83.751);
                    this.animateArm(arm_1, -7, 1000);
                    this.setInitialPosition(hand_1, -253.61, -85.467);
                    this.animateHand(hand_1, -252.61, -82.467, 0, 1000);
                    this.setInitialPosition(hand_2, -253.213, -84.893);
                    this.animateHand(hand_2, -252.213, -81.893, 0, 1000);
                }
                if(index === 1) {
                    let main_2 = this.$el.querySelector('#svgObject_'+index),
                        line_1 = this.getElement(main_2, '#Path_1127'),
                        line_2 = this.getElement(main_2, '#Path_1129'),
                        line_3 = this.getElement(main_2, '#Path_1132'),
                        line_4 = this.getElement(main_2, '#Path_1138'),
                        arm_2 = this.getElement(main_2, '#Path_1155'),
                        hand_3 = this.getElement(main_2, '#Path_1162'),
                        hand_4 = this.getElement(main_2, '#Path_1161'),
                        shoulder_1 = this.getElement(main_2, '#Path_1160');
                    this.setInitialPosition(line_1, -195.682, -203.572);
                    this.setInitialPosition(line_2, -195.933, -206.825);
                    this.setInitialPosition(line_3, -196.126, -211.704);
                    this.setInitialPosition(line_4, -196.414, -221.463);
                    this.setInitialPosition(arm_2, -267.662, -124.768);
                    this.setInitialPosition(hand_3, -264.189, -132.553);
                    this.setInitialPosition(hand_4, -265.975, -132.553);
                    this.setInitialPosition(shoulder_1, -273.902, -122.712);
                    this.animateLine(line_1, 0.2, '0% 0%', 5000);
                    this.animateLine(line_2, 0.2, '0% 0%', 7000, 2000);
                    this.animateLine(line_3, 3.5, '0% 0%', 3000, 1000);
                    this.animateLine(line_4, 2, '0% 0%', 4000, 4000);
                    this.animateArm(arm_2, -12, 2000);
                    this.animateHand(hand_3, -255.189, -125.553, 0, 2000);
                    this.animateHand(hand_4, -256.975, -125.553, 0, 2000);
                    this.animateArm(shoulder_1, -7, 2000);
                }
                if(index === 2) {
                    let main_3 = this.$el.querySelector('#svgObject_'+index),
                        paper_1 = this.getElement(main_3, '#Group_453'),
                        paper_2 = this.getElement(main_3, '#Group_456'),
                        paper_3 = this.getElement(main_3, '#Group_459'),
                        paper_4 = this.getElement(main_3, '#Group_462');
                    this.setInitialPosition(paper_1, 16.632, 11.104);
                    this.setInitialPosition(paper_2, 75.753, 0);
                    this.setInitialPosition(paper_3, 35.68, 8.499);
                    this.setInitialPosition(paper_4, 87.309, 5.645);
                    this.animatePapers([paper_1, paper_2, paper_3, paper_4], -10, 1000, 500);
                }
                if(index === 3) {
                    let main_4 = this.$el.querySelector('#svgObject_'+index),
                        case_1 = this.getElement(main_4, '#Group_543');
                    this.setInitialPosition(case_1, 65.457, 60.822);
                    this.animateCase(case_1, 0.8, 2000);
                }
            },
            initReportingFurtherAnimation() {
                let main = this.$el.querySelector('#reporting_further'),
                    point_1 = this.getElement(main, '#Path_1303'),
                    point_2 = this.getElement(main, '#Path_1306'),
                    point_3 = this.getElement(main, '#Path_1309'),
                    point_4 = this.getElement(main, '#Path_1312'),
                    line_1 = this.getElement(main, '#Path_1315');
                this.animateJourneyPoints([point_1, point_2, point_3, point_4], 4000);
                this.animateJourneyLine(line_1);
            },
            animateBubble(targets, scale, duration) {
                anime({
                    targets: targets,
                    keyframes: [
                        {scale: scale},
                        {scale: 1}
                    ],
                    duration: duration,
                    easing: 'linear',
                    direction: 'alternate',
                    loop: true
                })
            },
            animateArm(target, rotate, duration, origin = '100% 0%') {
                anime.set(target, {transformOrigin: origin, transformBox: 'fill-box'});
                anime({
                    targets: target,
                    rotate: rotate,
                    duration: duration,
                    direction: 'alternate',
                    easing: 'linear',
                    loop: true
                })
            },
            animateHand(hand, translateX, translateY, rotate, duration) {
                anime({
                    targets: hand,
                    translateX: translateX,
                    translateY: translateY,
                    rotate: rotate,
                    duration: duration,
                    direction: 'alternate',
                    easing: 'linear',
                    loop: true
                })
            },
            animateLine(line, scaleX, origin, duration,  delay = 0) {
                anime.set(line, {transformOrigin: origin, transformBox: 'fill-box'});
                anime({
                    targets: line,
                    scaleX: scaleX,
                    duration: duration,
                    direction: 'alternate',
                    easing: 'linear',
                    delay: delay,
                    loop: true
                })
            },
            animatePapers(papers, translateY, duration, stagger) {
                anime({
                    targets: papers,
                    translateY: translateY,
                    duration: duration,
                    direction: 'alternate',
                    delay: anime.stagger(stagger),
                    loop: true
                })
            },
            animateCase(target, scale, duration) {
                anime.set(target, {transformOrigin: '50% 50%', transformBox: 'fill-box'});
                anime({
                    targets: target,
                    scale: scale,
                    duration: duration,
                    direction: 'alternate',
                    easing: 'linear',
                    loop: true
                })
            },
            animateJourneyPoints(points, duration, stagger = 2000) {
                anime({
                    targets: points,
                    keyframes: [
                        {fill: '#407bff'},
                        {fill: '#407bff', opacity: '1'},
                    ],
                    duration: duration,
                    delay: anime.stagger(stagger),
                    // direction: 'alternate',
                    // easing: 'linear',
                    loop: true
                })
            },
            animateJourneyLine(line) {
                anime.set(line, {transformOrigin: '0% 0%', transformBox: 'fill-box', scaleY: 1.5, rotate: -1.6});
                // anime({
                //     targets: line,
                //     keyframes: [
                //         // {scaleY: 0},
                //         {scaleY: 0.5, rotate: 2, delay: 1000},
                //         {scaleY: 1, rotate: 0, delay: 1000},
                //         {scaleY: 1.5, rotate: -2, delay: 1000},
                //     ],
                //     // direction: 'alternate',
                //     duration: 4000,
                //     delay: 2000,
                //     easing: 'linear',
                //     loop: true
                // })
            }
        },
        mounted() {
            window.addEventListener('resize', this.setInnerWidth);
            this.setInnerWidth();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    }
</script>

<style scoped>
    li::before {
        content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
        color: #0174EA; /* Change the color */
        font-weight: bold; /* If you want it to be bold */
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 1em; /* Also needed for space (tweak if needed) */
        margin-left: -1em; /* Also needed for space (tweak if needed) */
    }

    li {
        padding-left: 1em;
    }
</style>